import React from 'react';
export function HowItWorksSection() {
  const phases = [{
    number: '01',
    title: 'Fase de Calma',
    days: 'Días 1-7',
    description: 'Reducimos la inflamación y estabilizamos el cortisol nocturno. Preparando el terreno para la quema de grasa.'
  }, {
    number: '02',
    title: 'Fase de Activación',
    days: 'Días 8-14',
    description: 'Introducimos micro-ayunos para enseñar al cuerpo a usar la grasa acumulada como energía de nuevo.'
  }, {
    number: '03',
    title: 'Fase de Consolidación',
    days: 'Días 15-21',
    description: 'Sellamos los nuevos hábitos para que tu metabolismo se mantenga activo y el peso no regrese.'
  }];
  return <section className="py-20 bg-beige" data-id="element-146">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-147">
        <div className="text-center mb-16" data-id="element-148">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-149">
            ¿Cómo funciona el método?
          </h2>
          <p className="text-lg text-taupe-light font-body" data-id="element-150">
            Un viaje de 21 días dividido en 3 fases estratégicas.
          </p>
        </div>

        <div className="relative" data-id="element-151">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-gold/30 -translate-y-1/2 z-0" data-id="element-152"></div>

          <div className="grid md:grid-cols-3 gap-8 relative z-10" data-id="element-153">
            {phases.map((phase, index) => <div key={index} className="flex flex-col items-center text-center" data-id="element-154">
                <div className="w-16 h-16 rounded-full bg-gold text-white flex items-center justify-center font-heading text-2xl font-bold mb-6 shadow-glow" data-id="element-155">
                  {phase.number}
                </div>
                <div className="bg-cream p-6 rounded-2xl shadow-soft w-full h-full border border-beige-light" data-id="element-156">
                  <span className="text-sm font-body font-bold text-gold uppercase tracking-wider mb-2 block" data-id="element-157">
                    {phase.days}
                  </span>
                  <h3 className="font-heading text-xl font-bold text-taupe mb-3" data-id="element-158">
                    {phase.title}
                  </h3>
                  <p className="font-body text-taupe-light text-sm leading-relaxed" data-id="element-159">
                    {phase.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}